<div class="modal-footer">
  <div class="footer-icon-row">
    @for (command of commands; track command; let i = $index) {
      <img
        [src]="command.icon"
        alt="Command icon"
        class="footer-icon"
        (click)="onCommandClick(i,mapEntity)"
        />
      }
    </div>
  </div>